class FitRow extends HTMLElement {
  connectedCallback() {
    this.fit = this.fit.bind(this);

    this.mutationObserver = new MutationObserver(() => {
      this.forceNowrap();
      this.fit();
    });
    this.mutationObserver.observe(this, { childList: true, subtree: true });

    this.resizeObserver = new ResizeObserver(this.fit);
    this.resizeObserver.observe(this);

    this.forceNowrap();
    this.fit();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  // Shopify's dynamic checkout button injects its own button list with a
  // layout that can wrap onto a second line at narrow widths. Force it
  // onto a single row so the scale-to-fit below has one line to work with.
  forceNowrap() {
    const buttons = this.querySelectorAll('.shopify-payment-button__button');
    if (!buttons.length) return;
    const list = buttons[0].parentElement;
    if (list && list.style.flexWrap !== 'nowrap') {
      list.style.display = 'flex';
      list.style.flexWrap = 'nowrap';
    }
  }

  fit() {
    const inner = this.firstElementChild;
    if (!inner) return;

    inner.style.transform = 'scale(1)';
    const containerWidth = this.clientWidth;
    const contentWidth = inner.scrollWidth;
    if (!containerWidth || !contentWidth) return;

    const scale = Math.min(1, containerWidth / contentWidth);
    inner.style.transform = `scale(${scale})`;

    const scaledHeight = Math.ceil(inner.getBoundingClientRect().height);
    if (this.style.height !== `${scaledHeight}px`) {
      this.style.height = `${scaledHeight}px`;
    }
  }
}

customElements.define('fit-row', FitRow);
